import { InMemoryCache, makeVar } from '@apollo/client'
import { persistCache, LocalStorageWrapper } from 'apollo3-cache-persist'
import { isProduction } from './config'
import { CognitoUser } from 'amazon-cognito-identity-js'

export const getCache = async (user: CognitoUser | null) => {
    const cache = new InMemoryCache({
        typePolicies: {
            TokenBalance: {
                keyFields: ['symbol', 'address', 'walletAddress', 'network'],
            },
            DirectPaymentTransactionReference: {
                keyFields: ['hash'],
            },
            GasPrice: {
                keyFields: ['network', 'lastBlock'],
            },
        },
    })
    if (!isProduction()) {
        const id = await user?.getUsername()
        await persistCache({
            cache,
            storage: new LocalStorageWrapper(window.localStorage),
            key: `apollo-cache-${id}`,
        })
    }

    return cache
}
